import type { Common, MstCommon } from '@libs/domain';
import { mstOrderItem } from '@libs/enums';
import type { OutputKeyObject } from '@ps-smart-cp/ppfw-client';
import { Order } from '@ps-smart-cp/ppfw-client';

export class OutputOrder implements Pick<MstCommon['schema'], 'outputKey'> {
  private constructor(readonly outputKey: OutputKeyObject) {}

  static init() {
    return new OutputOrder({ orderItem: mstOrderItem.enum.code, order: Order.asc });
  }
}

export class OutputOrderRaw implements Pick<Common['record'], 'order' | 'orderItem'> {
  private constructor(
    readonly orderItem: string,
    readonly order: string,
  ) {}

  static fromModel({ outputKey }: OutputOrder) {
    return new OutputOrderRaw(outputKey.orderItem, outputKey.order);
  }
}
